import React, { Component, Fragment } from 'react';
import AppHeader from '../Layout/AppHeader/';
import AppSidebar from '../Layout/AppSidebar/';
import AppFooter from '../Layout/AppFooter/';
import PageTitle from '../Layout/AppMain/PageTitle';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { properties } from '../constants/Propertise';
import {
    Row, Col, Card, CardBody
} from 'reactstrap';
import {Animated} from "react-animated-css";

class Error extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return(
            <Fragment>
                <AppHeader/>
                <div className="app-main">
                    <AppSidebar/>
                    <div className="app-main__outer">
                        <div className="app-main__inner">
							<ReactCSSTransitionGroup
								component="div"
								transitionName="TabsAnimation"
								transitionAppear={true}
								transitionAppearTimeout={0}
								transitionEnter={false}
								transitionLeave={false}
							>
								<div>
									<PageTitle
										heading={properties.errorPageText}
									/>
									<Row>
										<Col md="12">
											<Card className="main-card mb-3">
												<CardBody>
												<Animated
													animationIn="lightSpeedIn"
													animationOut="lightSpeedOut"
													isVisible={true}
												>
													<div className="text-center">
														<div
															className="swatch-holder text-center swatch-holder-lg bg-danger"
														/>
														<div
															className="swatch-holder swatch-holder-lg bg-danger"
														/>
														<div
															className="swatch-holder swatch-holder-lg bg-danger"
														/>
														<div
															className="swatch-holder swatch-holder-lg bg-danger"
														/>
													</div>
												</Animated>
													<div className="divider"/>
													<div className="form-row" style={{justifyContent :"center"}}>
														<div className="text-danger">
															{properties.errorPageTextMessage}
														</div>
													</div>
												</CardBody>
											</Card>
										</Col>
									</Row>
								</div>
							</ReactCSSTransitionGroup>
                        </div>
                        <AppFooter/>
                    </div>
                </div>
            </Fragment> 
        );
    }
}
export default Error;